const t = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.84097%208.77359H31.2938V27.1024L26.3612%2029.9461L26.3477%2013.7197H22.5472V32.1294L17.5876%2034.973V13.7197H13.7871V37.1563L8.84097%2040V8.77359ZM5%200H35.1213V4.94609L5%204.95957V0Z'%20fill='%23002456'/%3e%3c/svg%3e";
export {
  t as default
};
